var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetsIconsBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00006 9.99997L3.29306 10.707L2.58606 9.99997L3.29306 9.29297L4.00006 9.99997ZM21.0001 18C21.0001 18.2652 20.8947 18.5195 20.7072 18.7071C20.5196 18.8946 20.2653 19 20.0001 19C19.7348 19 19.4805 18.8946 19.293 18.7071C19.1054 18.5195 19.0001 18.2652 19.0001 18H21.0001ZM8.29306 15.707L3.29306 10.707L4.70706 9.29297L9.70706 14.293L8.29306 15.707ZM3.29306 9.29297L8.29306 4.29297L9.70706 5.70697L4.70706 10.707L3.29306 9.29297ZM4.00006 8.99997H14.0001V11H4.00006V8.99997ZM21.0001 16V18H19.0001V16H21.0001ZM14.0001 8.99997C15.8566 8.99997 17.6371 9.73747 18.9498 11.0502C20.2626 12.363 21.0001 14.1435 21.0001 16H19.0001C19.0001 14.6739 18.4733 13.4021 17.5356 12.4644C16.5979 11.5268 15.3261 11 14.0001 11V8.99997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsIconsBack);
export default __webpack_public_path__ + "static/media/lets-icons_back.de2b78744cb37ade8450117ac01f0acc.svg";
export { ForwardRef as ReactComponent };